import { motion } from "framer-motion";
import Container from "../../components/ui/container";
import { SiBootstrap, SiFramer, SiNextdotjs, SiVercel, SiTailwindcss, SiMongodb, SiShopify } from "react-icons/si";

const stats = [
  { value: "99%", label: "Client Satisfaction" },
  { value: "2+", label: "Years Average\nCandidate Experience" },
  { value: "70%", label: "Average Employee\nCost Savings" },
];

export default function Stats() {
  return (
    <section className="py-20 bg-[#1a1f36] text-white">
      <Container>
        <div className="space-y-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-2xl font-semibold mb-8">Trusted by America's Fastest Growing Brands</h2>
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
              <SiBootstrap className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
              <SiFramer className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
              <SiNextdotjs className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
              <SiVercel className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
              <SiTailwindcss className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
              <SiMongodb className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
              <SiShopify className="h-8 w-auto text-gray-400 hover:text-white transition-colors" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl font-semibold mb-8 text-center">Our achievements are widespread across fields</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="text-center"
                >
                  <p className="text-4xl font-bold text-white mb-2">{stat.value}</p>
                  <p className="text-gray-400 whitespace-pre-line">{stat.label}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}